import { gql } from "graphql-tag";

/**
 * Pass the product id once. Craft returns *one* entry per locale / site.
 * We only need lightweight meta to build the site-switch dropdown.
 */
const QUERY_MANUAL_SITES = gql`
  query ManualSites($id: [QueryArgument]!) {
    entries(id: $id, siteId: ["not", "-1"], status: ["enabled", "disabled"]) {
      id
      siteId
      siteHandle
      language
      title
    }
  }
`;
export default QUERY_MANUAL_SITES;
